/* jshint undef: true, unused: true */
/* globals globals */

require('../css/simple-grid.css');
require('../js/vendor/autoComplete/auto-complete.css');
require('../css/narco-wiz.css');

const objectPathToKey = require('./objectPathToKey');

const nJ = require('./not-jquery');
const FoBuComponentFactory = require('./fobu-components/fobu-component-factory');
const FoBuComponents = require('./form-builder-components');
const FoBuValidation = require('./form-builder-validation');

if(globals && globals.isRightToLeft) {
  const link = document.createElement('link');
  link.type  = 'text/css';
  link.rel   = 'stylesheet';
  link.href  = '/capture/js_functions/form-builder/css/narco-wiz-rtl.css';

  document.getElementsByTagName('head')[0].appendChild(link);
}

module.exports = function FormBuilder (targetElement, options, existingValues, isEdited = false) {
  let foBu = this;

  foBu.targetElement           = targetElement;
  foBu.isEdited                = isEdited;
  foBu.isDeletedForm           = false;
  foBu.validation              = new FoBuValidation(foBu);
  foBu.components              = new FoBuComponents();
  foBu.currentInputs           = [];
  foBu.eventListeners          = [];
  foBu.pageEventListeners      = [];
  foBu.autoCompleteInstances   = [];
  foBu.inputElementTypes       = ['hiddenwithtext', 'hidden', 'combo','autocomplete', 'date'];
  foBu.fieldsetTypes           = ['combo', 'radio', 'checkbox'];
  foBu.hasSubWrapper           = ['radio', 'checkbox','typeahead','inputwithbutton'];
  foBu.groupInputs             = ['radioOption', 'checkboxOption'];
  foBu.parentInputs            = ['combo', 'multicolumn'];
  foBu.noAppendInFinalisation  = ['date', 'multicolumn'];

  const validationMessage = txt.irm_field_required || 'This field is required';
  foBu.defaults                = {
    formAttributes  : {},
    labelClass      : null,
    uid             : 'foBu',
    inputNameSuffix : '',
    callback        : function () {
      console.error('callback function for form completion not defined');
    },
    defaultMessages : {
      required : validationMessage
    }
  };

  var privateDefaults = {
    hideInputsOfType : ['combo', 'hidden']
  };

  // List of supported element types that are inputs, not layout or supporting text etc.
  // List is used to filter elements when storing form state
  // n.b At time of writing, contains some inputs not yet implemented
  foBu.inputTypes = [
    // Subtypes of text input are handled by attributes property in element
    // definition passed in to options
    'input',
    'select',
    'textarea',
    'radio',
    'checkbox',
    'password',
    'color',
    'file',
    'hidden',
    'hiddenwithtext',
    'date',
    'typeahead',
    'inputwithbutton'
  ];

  foBu.buildForm = function (existingValues, options) {
    foBu.settings = foBu.compileSettings(foBu.defaults, options);

    if (existingValues) {
      foBu.existingValues = existingValues;
    } else {
      foBu.existingValues = {};
      foBu.setEmptyValues(foBu.settings.structure);
    }

    foBu.settings.getInputId = foBu.getInputId; // WHY ????

    foBu.pageIndex        = foBu.buildPageIndex();

    foBu.formElement = foBu.buildFormElement();
    foBu.targetElement.appendChild(foBu.formElement);

    foBu.buildStructure();

    foBu.populateInputs();
  };

  foBu.compileSettings = function (defaults, options) {

    var settings = $.extend( {}, defaults, options );

    settings.inputNameSuffix = options.inputNameSuffix || options.uid;

    if (settings.hideInputsOfType) {
      settings.hideInputsOfType.forEach(function (type){
        privateDefaults.hideInputsOfType.push(type);
      });
    }
    settings.hideInputsOfType = privateDefaults.hideInputsOfType;
    return settings;
  };

  foBu.setEmptyValues = function (structure) {

    Object.keys(structure).map(function (key) {
      var item = structure[key];

      foBu.existingValues[key] = '';
      if (foBu.parentInputs.includes(item.elementType)) {
        foBu.setEmptyValues(item.inputChildren);
      }
    });
  };

  foBu.buildPageIndex = function () {
    var pageIndex = [];
    Object.keys(foBu.settings.structure).map(function (key) {

      // Page validates whether numeric to catch things like a newline being passed in.
      // Todo: Track down source of newline, or kill redundant page system with fire somehow.
      var item = foBu.settings.structure[key],
          page = $.isNumeric(page) ? item.page : 0;

      if (!pageIndex[page]) {
        pageIndex[page] = {};
      }

      pageIndex[page][key] = item;
    });

    return pageIndex;
  };

  foBu.buildFormElement = function () {

    var formElement;
    formElement = document.createElement('div');

    formElement.submit = function () {
      foBu.saveFormState();

      const values = foBu.getInputValues();
      const submitFunction = foBu.isEdited ? foBu.settings.editRecord : foBu.settings.addNewRecord;
      submitFunction.bind(foBu);
      submitFunction(values);
    };

    formElement = foBu.addAttributes(formElement, foBu.settings.formAttributes);

    foBu.addAttributes(formElement, {
      'id'         : foBu.settings.uid,
      'novalidate' : 'novalidate'
    });

    nJ.addClass(formElement, 'foBu__form');

    if (foBu.pageIndex.length > 1) {
      formElement.appendChild(foBu.createProgressIndicator());
    }

    return formElement;
  };

  foBu.buildStructure = function () {

    var structure = foBu.getPageStructure();

    foBu.formContentWrapper = document.createElement('div');
    nJ.addClass(foBu.formContentWrapper, 'foBu__content');

    Object.keys(structure).map(function (itemIndex) {

      var elementSettings = structure[itemIndex];

      if (!elementSettings.globalSwitch || globals[elementSettings.globalSwitch] === true) {
        foBu.formContentWrapper.appendChild(foBu.createItem(elementSettings));
      }
    });

    if(!foBu.settings.isRecordDisplay) {
      foBu.addNewFormButtons();
    }

    foBu.formElement.appendChild(foBu.formContentWrapper);
  };


  foBu.createItem = function (elementSettings) {
    if (elementSettings.nonFormElement == true) {
      return foBu.createNonFormItem(elementSettings);
    } else {
      return foBu.createFormItem(elementSettings);
    }
  };


  foBu.createNonFormItem = function (elementSettings) {

    var wrapperClass = 'foBu__form-item-wrapper',
        elementType  = elementSettings.elementType || 'div',
        element      = document.createElement(elementType),
        elementId    = foBu.settings.uid + '__' + elementSettings.attributes.id,
        wrapper      = document.createElement('div');

    elementSettings.domElement = element;
    elementSettings.domWrapper = wrapper;

    foBu.addAttributes(element, elementSettings.attributes);
    nJ.addClass(wrapper, [wrapperClass, wrapperClass + '--' + elementType]);
    if (elementSettings.wrapperClass) {
      nJ.addClass(wrapper, elementSettings.wrapperClass);
    }

    elementSettings.id = elementId;

    nJ.addClass(element, 'form__' + elementType);

    wrapper.appendChild(element);

    return wrapper;
  };


  foBu.createFormItem = function (elementSettings) {

    elementSettings.elementType = elementSettings.elementType || 'input';

    var convertedComponents = [
          'hiddenwithtext',
          'multicolumn',
          'combo',
          'button',
          'select',
          'inputwithbutton',
          'autocomplete',
          'typeahead',
          'date'
        ],
        componentFactory,
        component,
        wrapper;

    // REFACTOR SUGGESTION: convertedComponents[] can be trashed and just run the factory on all elements
    if (convertedComponents.includes(elementSettings.elementType.toLowerCase())) {

      componentFactory = foBu.components[elementSettings.elementType.toLowerCase()];
      component        = new componentFactory(elementSettings, foBu),
      wrapper          = component.wrapper;

      component.finaliseComponent();
    } else {
      componentFactory = new FoBuComponentFactory(elementSettings, foBu);

      var componentObject = componentFactory.getComponentObject(),
          element         = componentObject.element,
          value;

      wrapper = componentObject.wrapper;

      elementSettings = componentObject.componentSettings;

      switch (elementSettings.elementType.toLowerCase()) {

        case 'radio'    :
        case 'checkbox' :

          element = document.createElement('div'),
          element = foBu.addRadioOrCheckboxOptions(element, elementSettings || {}, value || null);

          break;
      }

      componentFactory.finaliseComponent();
    }

    if (elementSettings.visibleCondition) {
        const condition = elementSettings.visibleCondition;
        const triggeringElementId = foBu.getInputId(
            condition.fieldName || elementSettings.attributes.id
        );
        const input = foBu.currentInputs.filter(function (input) {
            return input.attributes.id === triggeringElementId;
        })[0];

        if (!input) {
            console.error('Unable to locate triggering element with ID ' + triggeringElementId);
            return wrapper;
        }

        condition.targetElementId = wrapper.id;
        condition.targetInputId = elementSettings.attributes.id;

        foBu.manageEventListener(input.domElement, 'change', function (event) {
            const parentElement = jQuery('#' + condition.targetElementId);
            const elementHandles = [parentElement, parentElement.find('.foBu__form-item-child')];
            const selectedValue = event.target.value; // Note: this is currently assuming a field with a single input
            updateFieldVisibility(elementHandles, selectedValue)
        });

        updateFieldVisibility(jQuery(wrapper), foBu.existingValues[condition.fieldName]);

        function updateFieldVisibility(elementHandles, selectedValue) {
            if (condition.values.includes(selectedValue)) {
                for (let i = 0; i < elementHandles.length; i++) {
                    jQuery(elementHandles[i]).show();
                }

                if (elementSettings.validation && elementSettings.validation.required) {
                    foBu.validation.markRequired(condition.targetInputId);
                }
            } else {
                for (let i = 0; i < elementHandles.length; i++) {
                    jQuery(elementHandles[i]).hide();
                }

                foBu.validation.markNotRequired(condition.targetInputId);
            }
        }
    }

    return wrapper;
  };

  foBu.createLabel = function (inputId, inputSettings) {
    if (typeof inputSettings.label !== 'undefined') {

      var label = document.createElement('label');

      if (inputSettings.labelfor && typeof inputSettings.labelfor !== 'undefined' && inputSettings.labelfor !== false){
        foBu.addAttributes(label, {'for' : foBu.settings.uid + '__' + inputSettings.labelfor});
      } else if (typeof inputId !== 'undefined') {
        foBu.addAttributes(label, {'for' : inputId});
      }

      if (inputSettings.labelAttributes) {
        label = foBu.addAttributes(label, inputSettings.labelAttributes);
      }

      nJ.addClass(label, inputSettings.labelClass);
      nJ.addClass(label,['form__label', foBu.settings.labelClass]);

      if (inputSettings.attributes.required === 'required') {
        label.innerHTML = '<span class="form-item__label--required">*</span>';
      }
      label.innerHTML += inputSettings.label;
      return label;
    }
  };

  foBu.createProgressIndicator = function () {
    var steps = foBu.pageIndex.length;

    foBu.progressContainer              = document.createElement('progress');
    foBu.progressContainer.levelDisplay = document.createElement('span');

    foBu.addAttributes(foBu.progressContainer, {
      'value' : 1,
      'max'   : steps
    });

    foBu.progressContainer.appendChild(foBu.progressContainer.levelDisplay);

    foBu.manageEventListener(foBu.progressContainer, 'change', function (event) {
      foBu.progressContainer.levelDisplay.textContent = event.target.value;
    });

    foBu.progressContainer.textContent = '&npsp;of&npsp;' + steps;

    return foBu.progressContainer;
  };

  foBu.addNewFormButtons = function() {
    const wrapper      = document.createElement('div');
    const cancelButton = document.createElement('button');
    const submitButton   = document.createElement('button');
    cancelButton.setAttribute('type', 'button');
    submitButton.setAttribute('type', 'button');

    nJ.addClass(wrapper, ['foBu__form-item-wrapper', 'dtx-button-wrapper']);

    cancelButton.textContent = txt.cancel;
    nJ.addClass(cancelButton, ['dtx-button', 'dtx-button-small', 'dtx-button-small-min-width', 'button-clear']);
    foBu.manageEventListener(cancelButton, 'click', function(event) {
      foBu.settings.callableFunctions.cancelButtonAction(event, foBu.isEdited);
    });

    const addUpdateTextKey = foBu.isEdited ? 'update_'+ foBu.settings.formTypeTextKey : 'add_another_'+ foBu.settings.formTypeTextKey;
    submitButton.textContent = txt[addUpdateTextKey];

    foBu.manageEventListener(submitButton, 'click', function (event) {
      event.stopPropagation();
      event.preventDefault();
      if (event.currentTarget.parentElement.className === 'foBu__form-item-wrapper dtx-button-wrapper') {
        foBu.syncMedicationsDoseRowHiddenInputsValue();
      }
      if (foBu.validation.validate(foBu.settings.uid) === true) {
        foBu.formElement.submit();
      }
    });

    nJ.addClass(submitButton, ['foBu__save-button', 'dtx-button', 'dtx-button-small', 'dtx-button-small-min-width', 'button-primary']);

    wrapper.appendChild(cancelButton);
    wrapper.appendChild(submitButton);

    foBu.formContentWrapper.appendChild(wrapper);
  };

  foBu.updateMedicationsDoseRowHiddenInputsClassName = function() {
    const medicationsForm = document.getElementById('medications-record-form');
    if (medicationsForm === null) {
      return false;
    }
    const doseRow = medicationsForm.children[0].querySelector('#doseRow_medications-record-form-component-wrapper');
    const administeredDoseHiddenInput     = doseRow.querySelectorAll('#administeredAdministrationDosage_medications-record-form-component-wrapper #administeredAdministrationDosage_medications-record-form')[0];
    const intendedDoseHiddenInput         = doseRow.querySelectorAll('#intendedAdministrationDosage_medications-record-form-component-wrapper #intendedAdministrationDosage_medications-record-form')[0];
    administeredDoseHiddenInput.className = 'form-control form__combo INC-medications__administered-field';
    intendedDoseHiddenInput.className     = 'form-control form__combo INC-medications__intended-field';
  }

  foBu.syncMedicationsDoseRowHiddenInputsValue = function() {
    const medicationsForm = document.getElementById('medications-record-form');
    if (medicationsForm === null) {
      return false;
    }
    const doseRow = medicationsForm.children[0].querySelector('#doseRow_medications-record-form-component-wrapper');
    const administeredDoseValueInput  = doseRow.querySelectorAll('#administeredAdministrationDosage_medications-record-form-component-wrapper #administeredAdministrationDosageValue_medications-record-form')[0];
    const administeredDoseHiddenInput = doseRow.querySelectorAll('#administeredAdministrationDosage_medications-record-form-component-wrapper #administeredAdministrationDosage_medications-record-form')[0];
    const intendedDoseValueInput      = doseRow.querySelectorAll('#intendedAdministrationDosage_medications-record-form-component-wrapper #intendedAdministrationDosageValue_medications-record-form')[0];
    const intendedDoseHiddenInput     = doseRow.querySelectorAll('#intendedAdministrationDosage_medications-record-form-component-wrapper #intendedAdministrationDosage_medications-record-form')[0];
    if (administeredDoseHiddenInput.value === '') {
      administeredDoseHiddenInput.value = administeredDoseValueInput.value
    }
    if (intendedDoseHiddenInput.value === '') {
      intendedDoseHiddenInput.value = intendedDoseValueInput.value;
    }
  };

  foBu.saveFormState = function () {
    foBu.currentInputs.forEach(function (item) {
      if (foBu.groupInputs.includes(item.elementType)) {
        const element = foBu.targetElement.querySelector(`#${item.id}`);
        if (element.checked === true) {
          foBu.existingValues[item.attributes.name] = element.value;
        }
      } else {
        if (item.comboParent) {
          if (!foBu.existingValues[item.comboParent]) {
            foBu.existingValues[item.comboParent] = {};
          }
          foBu.existingValues[item.comboParent][item.attributes.name] = item.domElement.value;
          foBu.existingValues[item.attributes.name] = item.domElement.value;
        } else {
          foBu.existingValues[item.attributes.name] = item.domElement.value;
        }
      }
    });
  };

  foBu.addSearchIcon = function (element, elementSettings) {
    var searchAddOnButton = document.createElement('span');
    nJ.addClass(searchAddOnButton, ['foBu__' + elementSettings.inputWithButtonProps.addOn.class,'__icon--disabled']);
    return searchAddOnButton;
  };

  foBu.addRadioOrCheckboxOptions = function (parentElement, elementSettings, selectedOption) {
    var i       = 0,
        options = elementSettings.options;

    Object.keys(options).map(function (value) {

      var option    = $.extend( {}, options[value]),
          wrapper   = document.createElement('div'),
          id        = foBu.settings.uid + '__' + elementSettings.attributes.name + '--' + i,
          name      = elementSettings.attributes.name,
          labelText = option.label,
          element   = document.createElement('input'),
          label     = foBu.createRadioOrCheckboxLabel(id, labelText);

      foBu.addAttributes(element, {
        'type'  : elementSettings.elementType,
        'id'    : id,
        'name'  : name,
        'value' : value
      });

      if (selectedOption && selectedOption === value) {
        foBu.addAttributes(element, {'selected' : 'selected'});
      }

      wrapper.appendChild(element);
      wrapper.appendChild(label);
      option.id = id;
      if(!option.attributes) {
        option.attributes = {};
      }
      option.attributes.name  = name;
      option.attributes.value = value;
      option.domWrapper       = wrapper;
      option.domElement       = element;
      option.elementType      = elementSettings.elementType + 'Option';

      foBu.currentInputs.push(option);

      parentElement.appendChild(wrapper);

      i++;
    });

    return parentElement;
  };

  foBu.createRadioOrCheckboxLabel = function (elementId, labelText) {

    var label = document.createElement('label');

    foBu.addAttributes(label, {'for': elementId});
    nJ.addClass(label, 'form__label');

    label.innerHTML = labelText;
    return label;
  };

  foBu.addAttributes = function (element, attributesObject) {

    Object.keys(attributesObject).map(function (key) {
      var value = attributesObject[key];

      switch (key) {
        case 'class' :
          nJ.addClass(element, value);
          break;
        case 'html' :
          element.innerHTML = value;
          break;
        case 'name' :
          if(element.tagName !== 'DIV') {
            element.setAttribute(key, value);
          }
          break;
        default :
          element.setAttribute(key, value);
      }
    });

    return element;
  };

  foBu.getPageStructure = function () {
    return foBu.pageIndex[0];
  };

  // Gets an input from an array-like structure of element children.
  function getInputChild(elementChildren) {
    // Using Array.prototype.slice to convert array-like structure into
    // an array in a manner which is IE11-compatible.
    return Array.prototype.slice
      .call(elementChildren)
      .find(function (element) {
        return element.nodeName === 'INPUT';
      });
  }

  function isSelectedOption(opt) {
    return opt.selected;
  }
  function getOptionValue(opt) {
    return opt.value;
  }

  foBu.getInputValues = function () {
    const values = {};

    foBu.currentInputs.forEach(function (item) {
      var inputElement = item.domElement,
          inputName    = item.attributes.name,
          inputChild;

      if (item.inputElement) {
        inputElement = item.inputElement;
      }

      // Check whether the "inputElement" has children.
      if (inputElement.children.length > 0) {
        // If so, check whether it has a child which is an input.
        inputChild = getInputChild(inputElement.children);
        if (inputChild !== undefined) {
          // If so, assign the value.
          values[inputName] = inputChild.value;
        } else {
          // If not, assign the "inputElement" value.
          values[inputName] = inputElement.value;
        }
      } else {
        // If there are no children, just assign the "inputElement" value.
        values[inputName] = inputElement.value;
      }

      if (item.comboParent) {
        if (typeof values[item.comboParent] === 'undefined') {
          values[item.comboParent] = {};
        }

        if (item.useOptionsValue) {
          // Take the value of the selected option, rather than the description
          var selectedOption = item.options.filter(option => option.label === inputElement.value);
          if (selectedOption.length > 0) {
            values[item.comboParent][inputName] = selectedOption[0].value;
          } else {
            values[item.comboParent][inputName] = inputElement.value;
          }
        } else {
          values[item.comboParent][inputName] = inputElement.value;
        }
      }

      // Refactor: Ideally component values should be interpreted by a function encapsulated with the other functions for that component type.
      // In this case, we should be turning the contents of a multi-select into an array of selected values.
      if (item.elementType === 'select' && item.attributes.multiple) {
        values[inputName] = Array
          .from(item.domElement)
          .filter(isSelectedOption)
          .map(getOptionValue);
      }
    });

    return values;
  };


  foBu.getInputId = function (id, name) {
    var prefix = (typeof id !== 'undefined') ? id : name;
    return prefix + '_' + foBu.settings.inputNameSuffix;
  };

  foBu.getInputName = function (name) {
    return name + '_' + foBu.settings.inputNameSuffix;
  };

  foBu.populateInputs = function (argValues) {

    var values = argValues || foBu.existingValues;

    foBu.currentInputs.forEach(function (item) {

      var name = item.attributes.name,
          comboParent,
          value;

      if (
        typeof values[name] === 'undefined'
        &&
        typeof item.comboParent !== 'undefined'
        &&
        typeof values[comboParent] !== 'undefined'
        &&
        typeof values[comboParent][name] !== 'undefined'
      ) {
        comboParent = item.comboParent;
        value       = values[comboParent][name];
      } else {
        value = values[name];
      }

      foBu.updateField(item, value);

      if (item.populates) {
        var objectPath = objectPathToKey(foBu.getPageStructure(), item.populatedBy);
        if(objectPath) {
          foBu.updateField(objectPath.object, value);
        }
      }

    });
  };

  foBu.clearField = function (item) {
    foBu.updateField(item, '');
  };

  foBu.changeElementValue = function (element, newValue) {
    var origValue = element.value;
    element.value = newValue;

    // Changing an element value doesn't spawn a change event which we need in case addon buttons need resetting.
    // We dispatch a custom event instead (not needed for all elements)
    if(newValue === '' && typeof origValue !== 'undefined' && origValue !== newValue) {
      var clearedEvent = new CustomEvent('onClearedEvent', {
        bubbles: true,
        cancelable: false
      });

      element.dispatchEvent(clearedEvent);
    }
  }

  foBu.updateField = function (item, value) {
    var elementType = item.elementType || 'input',
        element     = item.domElement;

    if(!element) {
      return;
    }

    // N.B. Due to a bug where the foBu.currentInputs is being overwritten by the inputs of the most recent
    // instance in a layout with multiple instances.
    // As a result, after instantiation, this function is ignoring that array and finding the
    // elements on the fly. This is not desirable practice, and should be replaced as soon as it can be
    // worked out why the $@*! this is happening.
    if (element.id.indexOf(foBu.settings.uid) < 0) {
      const inputId = foBu.getInputId(item.attributes.name)
      element = foBu.targetElement.querySelector(`#${inputId}`);
    }
    // END

    if (foBu.groupInputs.includes(elementType)) {
      if (element.value === value) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    } else {
      if (typeof value !== 'undefined') {
        switch (elementType.toLowerCase()) {
          case 'typeahead' :
          case 'inputwithbutton' :
            foBu.changeElementValue(element.foBuSettings.inputElement, value);
            break;
          case 'hiddenwithtext' :
            var textElement = element.parentNode.getElementsByClassName('foBu__input-display-text');

            textElement[0].innerHTML = typeof item.display === 'function' ? item.display(value) : value;

            if (typeof item.options === 'object') {
              textElement[0].innerHTML = item.options[value] || value;
            } else {
              textElement[0].innerHTML = value;
            }

            // No break. Falls through to default.
          default :
            foBu.changeElementValue(element, value);
            break;
        }
      }
    }

    if (item.processInputs) {
      // Argh! It's a race condition!
      // Promises would be much better but fiddly and time consuming.
      // This is a horrible cludge. Volunteers gladly accepted...
      setTimeout(function() {
        foBu.settings.processInputsFunction(element, foBu);
      }, 50);
    }
  };

  foBu.updateComboHiddenField = function (element, inputChildren) {
    var comboValue = '';

    Object.keys(inputChildren).map(function(key) {
      var element = inputChildren[key].domElement;

      comboValue += element.value;
    });

    element.value = comboValue;
  };

  foBu.manageEventListener = function (element, event, handler, options) {

    options = options || {};

    if (options.context) {
      element.addEventListener(event, handler.bind(options.context), options);
    } else {
      element.addEventListener(event, handler.bind(foBu), options);
    }

    if (!options.once || options.once !== true) {
      foBu.eventListeners.push({
        element : element,
        event   : event,
        handler : handler
      });
      if (foBu.pageIndex.length > 1) {
        foBu.pageEventListeners.push({
          element : element,
          event   : event,
          handler : handler
        });
      }
    }
  };

  foBu.destroy = function () {
    if (foBu.eventListeners !== undefined && foBu.eventListeners.length > 0) {
      foBu.eventListeners.forEach(function (listener) {
        listener.element.removeEventListener(listener.event, listener.handler);
      });
    }

    if (foBu.autoCompleteInstances !== undefined && foBu.autoCompleteInstances.length > 0) {
      foBu.autoCompleteInstances.forEach(function (autoComplete) {
        autoComplete.destroy();
      });
    }

    foBu.isDeletedForm = true;
  };

  foBu.getIsFormDeleted = function() {
    return foBu.isDeletedForm;
  }

  foBu.buildForm(existingValues, options);

  return {
    form             : foBu.formElement,
    isEditedForm     : foBu.isEdited,
    getIsFormDeleted : foBu.getIsFormDeleted,
    validation       : foBu.validation,
    destroy          : foBu.destroy,
    structure        : foBu.settings.structure,
    populateInputs   : foBu.populateInputs,
    currentInputs    : foBu.currentInputs,
    getInputValues   : foBu.getInputValues,
    settings         : foBu.settings
  };
};
